@let headerSpacingClass = useLargeText ? 'pt-2' : 'py-1 mb-0';
@let cellPaddingClass = useLargeText ? 'py-2' : 'pb-2';

<div class="h-full w-full si-card">
  <div
    class="border-b px-4 py-2 flex items-center justify-between"
  >
    <h3
      [ngClass]="headerSpacingClass"
    >
      Exports
    </h3>
    <button
      matButton="outlined"
      type="button"
      class="mat-small-button mr-1 card-menu si-menu-trigger"
      [matMenuTriggerFor]="exportButtonMenu"
      [disabled]="!exportsData"
    >
      <span class="si-card-menu-content">
        <span class="si-card-menu-label">{{ selectedOption }}</span>
        <span class="si-menu-trigger-icon" aria-hidden="true"></span>
      </span>
    </button>
    <mat-menu #exportButtonMenu>
      <ng-template matMenuContent>
        <button mat-menu-item (click)="updateSelectedOption('All')">
          <i class="export-icon all"></i>All
        </button>
        <button
          mat-menu-item
          *ngIf="accountAttributesEnum.CSVEXPORT | hasAccessAsync | async"
          (click)="updateSelectedOption('CSV', exportsSummaryEnum.CSV)"
        >
          <i class="export-icon csv"></i>CSV
        </button>
        <button
          mat-menu-item
          *ngIf="'dyEmail' | userMetaDataByKey | async"
          (click)="
            updateSelectedOption(
              'Dynamics 365',
              exportsSummaryEnum.Dynamics_365
            )
          "
        >
          <i class="export-icon dynamics"></i>Dynamics 365
        </button>
        <button
          mat-menu-item
          *ngIf="'hsEmail' | userMetaDataByKey | async"
          (click)="updateSelectedOption('HubSpot', exportsSummaryEnum.HubSpot)"
        >
          <i class="export-icon hubspot"></i>HubSpot
        </button>
        <button
          mat-menu-item
          *ngIf="'mktUser' | userMetaDataByKey | async"
          (click)="updateSelectedOption('Marketo', exportsSummaryEnum.Marketo)"
        >
          <i class="export-icon marketo"></i>Marketo
        </button>
        <button
          mat-menu-item
          *ngIf="'orEmail' | userMetaDataByKey | async"
          (click)="updateSelectedOption('Outreach', exportsSummaryEnum.Outreach)"
        >
          <i class="export-icon outreach"></i>Outreach
        </button>
        <button
          mat-menu-item
          *ngIf="'sfEmail' | userMetaDataByKey | async"
          (click)="
            updateSelectedOption('Salesforce', exportsSummaryEnum.Salesforce)
          "
        >
          <i class="export-icon salesforce"></i>Salesforce
        </button>
        <button
          mat-menu-item
          *ngIf="'slEmail' | userMetaDataByKey | async"
          (click)="
            updateSelectedOption('Salesloft', exportsSummaryEnum.Salesloft)
          "
        >
          <i class="export-icon salesloft"></i>Salesloft
        </button>
        <button
          mat-menu-item
          *ngIf="'zhEmail' | userMetaDataByKey | async"
          (click)="updateSelectedOption('Zoho', exportsSummaryEnum.Zoho)"
        >
          <i class="export-icon zoho"></i>Zoho
        </button>
        <button
          mat-menu-item
          (click)="updateSelectedOption('Reveals', exportsSummaryEnum.Reveals)"
        >
          <span class="inline-flex items-center justify-center w-5 h-5 mr-2.5 translate-y-[3px]"><fa-icon class="si-icon text-primary-light text-[18px]" [icon]="['fas', 'eye']"></fa-icon></span>Reveals
        </button>
      </ng-template>
    </mat-menu>
  </div>

  <div class="h-full" *ngIf="!exportsData || isLoading; else exportsCard">
    <div class="flex justify-center items-center h-full w-full">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <ng-template #exportsCard>
    <ng-container *ngIf="exportsData?.length === 0; else exportsSummary">
      <div class="flex flex-col overflow-hidden h-full w-full p-4">
        <p *ngIf="useLargeText" class="mb-1 text-si-h4 font-normal text-center">
          Companies and contacts exported
        </p>
        <div
          class="flex flex- pt-1 pb-12 px-12 flex-wrap justify-center h-full items-center"
        >
          <p
            class="text-center pb-2 text-secondary font-medium empty-state-text"
          >
            You have not exported any companies or contacts on your account.
          </p>
        </div>
      </div>
    </ng-container>
    <ng-template #exportsSummary>
      <div class="flex flex-col overflow-hidden h-full w-full p-4">
        <p *ngIf="useLargeText" class="mb-1 text-si-h4 font-normal text-center">
          Companies and contacts exported
        </p>
        <div class="grid-data flex-1 flex items-center w-full h-full" [class.mb-3]="useLargeText">
            <table class="align-middle text-center w-full">
                <colgroup>
                    <col style="width: 30%;">
                    <col style="width: 23.3%;">
                    <col style="width: 23.3%;">
                    <col style="width: 23.3%;">
                </colgroup>
                <tbody>
                    <tr>
                        <td [ngClass]="cellPaddingClass"></td>
                        <td class="text-right text-si-h4" [ngClass]="cellPaddingClass">Past 30 Days</td>
                        <td class="text-right text-si-h4" [ngClass]="cellPaddingClass">Past 90 Days</td>
                        <td class="text-right text-si-h4" [ngClass]="cellPaddingClass">All Time</td>
                    </tr>
                    <tr>
                        <td class="text-left text-si-h4" [ngClass]="cellPaddingClass">Companies</td>
                        <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">
                            {{ exportsData.past30_days_total_company_exported | numberAbbreviator }}
                        </td>
                        <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">
                            {{ exportsData.past90_days_total_company_exported | numberAbbreviator }}
                        </td>
                        <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">
                            {{ exportsData.total_company_exported | numberAbbreviator }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-si-h4" [ngClass]="cellPaddingClass">Contacts</td>
                        <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">
                            {{ exportsData.past30_days_total_contact_exported | numberAbbreviator }}
                        </td>
                        <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">
                            {{ exportsData.past90_days_total_contact_exported | numberAbbreviator }}
                        </td>
                        <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">
                            {{ exportsData.total_contact_exported | numberAbbreviator }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
